import React, { useState, useMemo, useEffect } from 'react';
import { RiHomeOfficeFill } from 'react-icons/ri';
import { BsBuilding,BsCalendar2Check, BsSearch, BsClock  } from 'react-icons/bs';
import { TbZoomReset } from 'react-icons/tb';
import { useForm } from "react-hook-form";
import { useOffice } from "../../../../hooks/useOffice";
import DataTable from '../../../../components/ui/DataTable';
import Spinner from "../../../../components/Spinner";
import { formatCurrency, sqlDateFormat } from '../../../../utils/Common';
import SelectSearch from '../../../../components/ui/SelectSearch';
import NotifyC from '../../../../components/Notifications';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import TimeRangePicker from 'rsuite/TimeRangePicker';
import CustomProvider  from 'rsuite/CustomProvider';
import * as locales from 'rsuite/locales';
import 'rsuite/TimeRangePicker/styles/index.css';
import './index.css';

const SearchPostOffices = () => {
    const { getAllPostOfficesMovements, getPostOfficeStatus } = useOffice();
    const { handleSubmit, reset, errors } = useForm();
    const [postOffices, setPostOffices] = useState([]);
    const [listOffice, setListOffice] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [hasSearched, setHasSearched] = useState(false);
    const [officeSelected, setOfficeSelected] = useState("");
    const [dateRange, setDateRange] = useState([null, null]);
    const [startDate, endDate] = dateRange;
    const [time, setTime] = useState([]);
    const [start, end] = Array.isArray(time) ? time : [new Date(), new Date()];
    const data = Object.keys(locales).map(key => ({
        key: key.replace(/([a-z]{2})([A-Z]{2})/, '$1-$2'),
        value: locales[key]
      }));
    const [localeKey, setLocaleKey] = useState('es-ES');
    const locale = data.find(item => item.key === localeKey);


 
    const handleGetListOffices = async () => {
        try {
        const abortController = new AbortController();
        const response = await getPostOfficeStatus(abortController.signal);
       
        if (response?.payload?.length > 0) {
            setListOffice(response.payload);
        } else {
            setListOffice([]);
            NotifyC.error("No se pudo obtener la lista de estafetas");
        }
        }catch (error) {
        console.error(error);
        }
    };

    const resetForm = () => {
        reset();
        setOfficeSelected("");
        setDateRange([null, null]);
        setPostOffices([]);
        setHasSearched(false);
        setTime([]);
    };

    const formatTime = (date) => {
    
        if (!(date instanceof Date) || isNaN(date)) {
            return null; 
        }
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        return `${hours}:${minutes}`;
    };

    const handleOnSubmit = async () => {
        
        if (!officeSelected) {
            NotifyC.error("Por favor, selecciona una estafeta.");
            return;
        }

        if (!startDate && !endDate && start && end) {
            NotifyC.error("Por favor, selecciona un rango de fechas."); 
            return;
        }

        if (startDate && endDate && new Date(startDate) > new Date(endDate)) {
            NotifyC.error("La fecha 'Desde' no puede ser mayor que la fecha 'Hasta'.");
            return;
        }
    
        const dataToSend = {
            IdPostOffice: officeSelected,
            type: '3,4',
            fechaDesde: startDate ? startDate : null, 
            fechaHasta: endDate ? endDate : null, 
            horaDesde: start ? formatTime(start): null,
            horaHasta: end? formatTime(end) : null,
        };
        
        setIsLoading(true);
    
        try {
            const abortController = new AbortController();
            const response = await getAllPostOfficesMovements(abortController.signal, dataToSend);
            
            if (response?.code === 200) {
                const updatedInfoOffice = response.payload.map((mov) => {
                    return {
                        id: mov.IdSucursal || 0,
                        code: mov.Codigo || "",
                        name: mov.NombreSucursal || "",
                        nameCode: (mov.Codigo || "") + ' ' + (mov.NombreSucursal || ""),
                        location: mov.Direccion || "",
                        IdTipoMovimiento: mov.IdTipoMovimiento || 0,
                        FechaMovimientoCajeroType: mov.FechaMovimientoCajeroType || "",
                        MontoMovimiento: mov.MontoMovimiento || 0,
                        saldoAsignado: mov.IdTipoMovimiento === 3 ? mov.MontoMovimiento : 0,
                        saldoRetirado: mov.IdTipoMovimiento === 4 ? mov.MontoMovimiento : 0,
                        SaldoEstafeta: mov.SaldoFinalEstafeta ?? 0,
                        SaldoOperacion: mov.SaldoOperacion ?? 0,
                        RemCreadas: mov.RemCreadas ?? 0,
                        RemPendiente: mov.RemPendiente ?? 0,
                        totalBalance: (mov.SaldoFinalEstafeta || 0) + (mov.SaldoOperacion || 0) - (mov.RemPendiente || 0),
                    };
                });
                
                NotifyC.success(`Movimientos de la estafeta ${updatedInfoOffice[0]?.nameCode} encontrados.`);
                setPostOffices(updatedInfoOffice || []);
             
                setHasSearched(true);
            } else {
                if (response?.message === "POSTOFFICE_MOVEMENTS_NOT_FOUND") {
                NotifyC.error("No se encontraron movimientos para la estafeta seleccionada.");
                }
            }
        } catch (error) {
            console.error(error);
            NotifyC.error("No se pudieron cargar los datos. Por favor, inténtalo de nuevo.");
        } finally {
            
            setIsLoading(false);
        }
    };

    const handleSelect = (name, value) => {
        if (name === "office") {
            setOfficeSelected(value);
        }
    };

    const handleNameMovimientos = (id) => {
        if (id === undefined) return ""; 
        switch (id) {
            case 3: return "Saldo Asignado";
            case 4: return "Saldo Retirado";
            default: return "";
        }
    };

    const renderOriginSelectOffice = (nameInput, title) => { 
        const options = listOffice.map(office => ({
        value: office.IdSucursal || "",
        label: (office.NombreProvincia + ' - ' + office.NombreSucursal) || ""
        }));
        return (
            <div className="col-12 col-md-6 input-group text-left mb-3">
                <div className="d-flex w-100">
                    <div className="input-group-prepend d-flex align-items-center">
                        <span className="input-group-text text-bold input-label" style={{ backgroundColor: "#FBD825", color: "black", borderRadius: "6px 0 0 6px" }}>
                            <BsBuilding className="mr-2" size={18} /> {title}
                        </span>
                    </div>
                    <SelectSearch options={options} nameInput={nameInput} setValue={handleSelect} value={officeSelected} />
                </div>
            </div>
        );
    };

    const columns = useMemo(() => [
        {  
            Header: "Fecha", accessor: "FechaMovimientoCajeroType", id: "fecha",
            Cell: ({ value }) => value ? sqlDateFormat(value, false, true).split('-')[0]  : "", 
            exportable: true 
        },
        {   
            Header: "Hora", accessor: "FechaMovimientoCajeroType", id: "hora",
            Cell: ({ value }) => value ? sqlDateFormat(value, false, true).split('-')[1] : "", 
            exportable: true 
        },
        { Header: "Nombre", accessor: "nameCode", exportable: false },
        { Header: "Movimiento", accessor: "IdTipoMovimiento", Cell: ({ value }) => handleNameMovimientos(value), exportable: true },
        { Header: "Monto", accessor: "MontoMovimiento", Cell: ({ value }) => value ? formatCurrency(value) : "", exportable: true, isTotalizable: true },
        { Header: "Saldo de estafeta", accessor: "SaldoEstafeta", Cell: ({ value }) => formatCurrency(value), exportable: true, isTotalizable: true },
        { Header: "Saldo en operación", accessor: "SaldoOperacion", Cell: ({ value }) => formatCurrency(value), exportable: true, isTotalizable: true },
        { Header: "Giros recibidos", accessor: "RemCreadas", Cell: ({ value }) => formatCurrency(value), exportable: true, isTotalizable: true },
        { Header: "Giros por entregar", accessor: "RemPendiente", Cell: ({ value }) => formatCurrency(value), exportable: true, isTotalizable: true },
        { Header: "Balance total", accessor: "totalBalance", Cell: ({ value }) => formatCurrency(value), exportable: true, isTotalizable: true },
    ], []);

    useEffect(() => {
        handleGetListOffices();
    }, []);

    return (
        <>
            <div className="dashboardCard text-left" style={{ color: "black", marginBottom: "20px" }}>
                <div className="d-flex justify-content-between" style={{ gap: 20 }}>
                    <div className="d-flex align-items-center">
                        <RiHomeOfficeFill size={20} className="mr-2" />
                        <h5 className="mb-0">Búsqueda de Estafeta</h5>
                    </div>
                </div>
            </div>
            <div className="dashboardCard p-3" style={{ color: "black" }}>
                <div className="d-flex justify-content-between flex-wrap mb-2">
                    <p className="mb-0">Filtros de búsqueda</p>
                </div>
                <form onSubmit={handleSubmit(handleOnSubmit)}>
                    <div className="row"style={{ flex: 0.5}}>
                        {renderOriginSelectOffice("office", "Estafeta")}
                        <div className="col-12 col-md-6 input-group text-left mb-3 customDatePickerWidth" style={{ width: "100%" }}>

                            <div className="input-group-prepend d-flex align-items-center">
                                <span className="input-group-text text-bold input-label" style={{ backgroundColor: "#FBD825", color: "black" }}>
                                    <BsCalendar2Check className="mr-2" size={18} /> Rango de Fechas
                                </span>
                            </div>
                            <DatePicker
                                type="text"
                                selectsRange={true}
                                startDate={startDate}
                                endDate={endDate}
                                onChange={(update) => setDateRange(update)}
                                name="dateRange"
                                isClearable={true}
                                placeholderText="Selecciona un rango de fechas"
                                className="form-control input-field w-100"
                                dateFormat="dd/MM/yyyy"
                                style={{ flexGrow: 1, width: "100%", minWidth: "300px" }}
                            />
                        </div>
                         <div className="col-12 col-md-6 input-group text-left mb-3"style={{ width: "100%" }} >
                            <div className="input-group-prepend d-flex align-items-center ">
                                <span className="input-group-text text-bold input-label pb-1" style={{ backgroundColor: "#FBD825", color: "black" }}>
                                    <BsClock className="mr-2" size={18} /> Rango de Horas
                                </span>
                            </div>
                            <CustomProvider locale={locale.value}>
                            <TimeRangePicker 
                                format="hh:mm aa"
                                showMeridiem 
                                className="input-field w-100 "
                                value={time}
                                onChange={setTime}
                                placeholder="Selecciona un rango de horas"
                            />
                            </CustomProvider>
                        </div>
                    </div>
                   <div className="d-flex justify-content-center mt-3" style={{ gap: "12px" }}>
                        {isLoading ? (
                            <button type="submit" className="btn btn-blue" disabled> Buscar</button>
                        ) : (
                            <button type="submit" className="btn btn-blue"><BsSearch /> Buscar</button>
                        )}
                        <button type="reset" className="btn btn-secondary" onClick={resetForm}><TbZoomReset size={20} /> Reiniciar</button>
                    </div>
                </form>
            </div>

            {hasSearched && postOffices.length > 0 && !isLoading && (
                <div className="dashboardCard p-3" style={{ color: "black" }}>
                    <DataTable
                        columns={columns}
                        data={postOffices}
                        tableTitle="Resultados de la búsqueda"
                        filename="reporte-estafetas"
                        exportExcel
                        exportPdf
                        exportableColumns={columns.filter(column => column.exportable)}
                        nameReport='REPORTE ESTAFETA'
                        col={+2.4-1-.5-.5}
                        row={0}
                        includeTotals={true}
                        sucursalSelected={postOffices[0]?.nameCode}
                        logTypeExcel={6}
                        logTypePdf={10}
                        IdSucursal={officeSelected}
                    />
                </div>
            )}

            {isLoading && (
                <div className="dashboardCard d-flex justify-content-center align-items-center p-3" style={{ color: "black" }}>
                <div className="text-center ">
                     <Spinner type={2} size={40} color="black" />
                    </div>
                </div>
              
            )}
        </>
    );
};

export default SearchPostOffices;